/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 亚运会
 * @LastEditTime: 2024-06-29 19:11:02
 */

import bigSports_mixin from '@mixins/compreSportsMeet/ASG/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_CSMeet_ASG',
      defaultPath: ['compreSportsMeet', 'asianGames', 'schedule'],
      axiosBaseUrl: '/sog', // '/asg',
      sportCompetitionType: 'compreSportsMeet_ASG', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['ASG2026', 'ASG19'],
          themeIndex: 0,
        },
      ],
    }
  },
}
